const o = {
  border: 0,
  borderStyle: "solid",
  "&[data-orientation=horizontal]": {
    width: "100%",
    borderBottomWidth: (t) => t.spacing(0.25)
  },
  "&[data-orientation=vertical]": {
    height: "auto",
    alignSelf: "stretch",
    borderRightWidth: (t) => t.spacing(0.25)
  }
}, r = {
  separator: o
};
export {
  r as separatorsTheme
};
